export enum AgentType {
    Client = 1,
    Employee = 7,
    CustomerEmployee = 8
}